/*
 * $Id:: index.js 2021/12/13 12:44 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState, useEffect } from 'react';

import Collapse from '@material-ui/core/Collapse';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import UnfoldLessIcon from '@material-ui/icons/UnfoldLess';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';

import { t } from '../../providers';
import VerticalMenu from '../VerticalMenu';
import CorrespondenceTableHeader from './CorrespondenceTableHeader';

const useStyles = makeStyles((theme) => ({
    actions: {
        width: '3%',
    },
    subActions: {
        width: '6%',
    },
    tableContainer: {
        minHeight: '200px',
        '@media (max-width:960px)': {
            width: 'calc(100vw - 80px)',
        },
        '& .MuiIconButton-root': {
            padding: '0',
        },
        '& .openButton': {
            fontWeight: 600,
            fontSize: theme.typography.fontSize,
            lineHeight: '20px',
            textDecoration: 'unset',
            color: theme.palette.text.mainBlue,
        },
        '& $classNew .openButton': {
            color: theme.palette.text.blue900,
        },
    },
    headCell: { height: '48px', padding: '0 16px' },
    incomingRow: { height: '74px' },
    outgoingRow: { height: '64px' },
    imageCell: {
        textAlign: 'center',
        height: '40px',
    },
    classNew: {
        color: theme.palette.text.blue900,
        background: 'linear-gradient(90deg, #80ACFF 8px, #F0F5FF 8px)',
        '& $mainCell': {
            fontWeight: 600,
            color: theme.palette.text.blue900,
            '& a': {
                color: theme.palette.text.blue900,
            },
        },
        '& .receivedDateIcon': { color: theme.palette.text.blue900 + '!important', borderColor: theme.palette.text.blue900 + '!important' },
    },
    mainCell: {
        maxWidth: '100px',
    },
    actionsCell: {
        maxWidth: '200px',
    },
    subCell: {
        maxWidth: '100px',
        padding: '16px 0px',
    },
    smallSubCell: {
        maxWidth: '85px',
        padding: '16px 0px',
    },
    smallUbStatusCell: {
        maxWidth: '40px',
        padding: '16px 0px',
    },
    collapseIcon: {
        textOverflow: 'unset',
        width: 30,
        maxWidth: 30,
        minWidth: 30,

        '@media (min-width:1920.98px)': {
            width: '5%',
            maxWidth: '5%',
            minWidth: '5%',
        },

        '& svg': {
            fill: '#2F509A',
        },
    },
    'cell-0': {
        width: 100,
        maxWidth: 125,
        minWidth: 100,
        boxSizing: 'border-box',

        '@media (min-width:1920.98px)': {
            width: '6%',
            maxWidth: '6%',
            minWidth: '6%',
        }
    },
    'cell-2': {
        width: 200,
        maxWidth: 200,
        minWidth: 200,
        boxSizing: 'border-box',

        '@media (min-width:1920.98px)': {
            width: '13%',
            maxWidth: '13%',
            minWidth: '13%',
        }
    },
    'cell-3': {
        width: 260,
        maxWidth: 260,
        minWidth: 260,
        boxSizing: 'border-box',

        '@media (min-width:1920.98px)': {
            width: '18%',
            maxWidth: '18%',
            minWidth: '18%',
        }
    },
    'cell-4': {
        width: 150,
        maxWidth: 185,
        minWidth: 150,
        boxSizing: 'border-box',

        '@media (min-width:1920.98px)': {
            width: '10%',
            maxWidth: '10%',
            minWidth: '10%',
        }
    },

    'cell-5': {
        width: 150,
        maxWidth: 185,
        minWidth: 150,
        boxSizing: 'border-box',

        '@media (min-width:1920.98px)': {
            width: '10%',
            maxWidth: '10%',
            minWidth: '10%',
        }
    },
    'cell-6': {
        width: 180,
        maxWidth: 180,
        minWidth: 180,
        boxSizing: 'border-box',

        '@media (min-width:1920.98px)': {
            width: '12%',
            maxWidth: '12%',
            minWidth: '12%',
        }
    },
    'cell-7': {
        width: 120,
        maxWidth: 120,
        minWidth: 120,
        boxSizing: 'border-box',
        textAlign: 'left !important',

        '@media (min-width:1920.98px)': {
            width: '8%',
            maxWidth: '8%',
            minWidth: '8%',
        }
    },
     'cell-8': {
         width: 200,
         maxWidth: 200,
         minWidth: 200,
         boxSizing: 'border-box',
         textAlign: 'right !important',

        '@media (min-width:1920.98px)': {
            width: '13%',
            maxWidth: '13%',
            minWidth: '13%',
        }
     },
}));

/**
 * correspondence table component
 * @param {object} obj
 * @param {string} obj.sortBy
 * @param {string} obj.sortType
 * @param {function} obj.setSorting
 * @param {object} obj.correspondence
 * @param {string} obj.tableId
 */
const CorrespondenceTable = ({ sortBy, sortType, setSorting, correspondence, tableId = 'correspondenceTable' }) => {
    const classes = useStyles();
    const [openCollapse, setOpenCollapse] = useState([]);

    useEffect(() => {
        if (correspondence.data) {
            let hasSubRows = [];
            correspondence.data.forEach((corr, corrIdx) => {
                if (corr[9].subrows) {
                    hasSubRows.push({ corrIdx: corrIdx, open: false });
                }
            });
            setOpenCollapse(hasSubRows);
        }
    }, [correspondence]);

    const tableHead = (
        <CorrespondenceTableHeader
            classes={classes}
            setSorting={setSorting}
            sortBy={sortBy}
            sortType={sortType}
            headers={correspondence.headers || []}
            tableId={tableId}
        />
    );

    /**
     * handle open row
     * @param {string} id
     */
    const setOpenRow = (id) => {
        let updOpenRow = [];
        openCollapse.forEach((row) => {
            let updatedRow = row;
            if (row.corrIdx === id) {
                updatedRow = { corrIdx: row.corrIdx, open: !row.open };
            }
            updOpenRow.push(updatedRow);
        });
        setOpenCollapse(updOpenRow);
    };

    /**
     * check if cor/nce row is open
     * @param {string} id
     */
    const isOpen = (id) => {
        let opened = false;
        openCollapse.forEach((row) => {
            if (row.corrIdx === id && row.open) {
                opened = true;
            }
        });
        return opened;
    };

    return (
        <TableContainer className={classes.tableContainer}>
            <Grid item xs={12}>
                {correspondence && correspondence.headers && correspondence.headers.length > 0 && (
                    <Table id={`table-${tableId}`} aria-label="simple table">
                        {tableHead}
                        <TableBody className={classes.body}>
                            {(!correspondence.data || correspondence.data.length === 0) && (
                                <TableRow className={classes.row}>
                                    <TableCell colSpan={correspondence.headers.length + 2} align="center">
                                        {t('no.correspondence')}
                                    </TableCell>
                                </TableRow>
                            )}
                            {(correspondence.data || []).map((corr, corrIdx) => {
                                const { subrows } = corr.find((item) => item.label === 'subrows');
                                return (
                                    <React.Fragment key={corrIdx}>
                                        <TableRow
                                            key={corrIdx}
                                            className={[classes.incomingRow, corr[0].blueBackground ? classes.classNew : null].join(' ')}
                                            style={{ backgroundColor: '#FFFFFF' }}>
                                            <TableCell className={classes.collapseIcon}>
                                            {subrows.length > 0 && (
                                                    <IconButton aria-label="expand row" size="small" onClick={() => setOpenRow(corrIdx)}>
                                                        {isOpen(corrIdx) ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
                                                    </IconButton>
                                                )}
                                                </TableCell>
                                            {corr.map((item, idx) => {
                                                const cellClass = item.label === 'actions' ? classes.actionsCell : classes.mainCell;
                                                return (
                                                    <React.Fragment key={idx}>
                                                        {item.label === 'menuItems' ? (
                                                            <TableCell className={`${classes.actions} ${classes[`cell-${idx}`]}`} align="left">
                                                                <VerticalMenu
                                                                    actionButtonId={`${tableId}-table-actionButton-${corrIdx}`}
                                                                    menuItems={item.value}
                                                                />
                                                            </TableCell>
                                                        ) : (
                                                            <TableCell align="left" id={idx} className={`${cellClass} ${classes[`cell-${idx}`]}`}>
                                                               {item.value}
                                                            </TableCell>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })}
                                        </TableRow>
                                        {!!subrows.length && isOpen(corrIdx) && (
                                            <TableRow>
                                                <TableCell style={{ padding: 0, borderBottom: 'unset', backgroundColor: '#FCFCFC' }} colSpan={10}>
                                                    <Collapse in={isOpen(corrIdx)} timeout="auto" unmountOnExit>
                                                            <Table className={classes.subTable} aria-label="purchases">
                                                                <TableBody>
                                                                    {!!subrows.length &&
                                                                        subrows.map((items, idx) => (
                                                                            <TableRow
                                                                                className={classes.outgoingRow}
                                                                                key={idx}
                                                                                style={{ backgroundColor: '#FCFCFC' }}>
                                                                            <TableCell className={classes.collapseIcon}></TableCell>
                                                                                {items.map((item, index) => {
                                                                                    const cellClass =
                                                                                        item.label === 'graphicalRepresentation'
                                                                                            ? classes.imageCell
                                                                                            : '';

                                                                                    return (
                                                                                        <React.Fragment key={index}>
                                                                                            {item.label === 'menuItems' ? (
                                                                                            <TableCell className={`${classes.actions} ${classes[`cell-${index}`]}`} align="left">
                                                                                                    <VerticalMenu
                                                                                                        actionButtonId={`${tableId}-table-actionButton-${corrIdx}`}
                                                                                                        menuItems={item.value}
                                                                                                    />
                                                                                                </TableCell>
                                                                                            ) : (
                                                                                                <TableCell
                                                                                                    align={item.align || 'left'}
                                                                                                className={`${cellClass} ${classes[`cell-${index}`]}`}>
                                                                                                   {item.value}
                                                                                                </TableCell>
                                                                                            )}
                                                                                        </React.Fragment>
                                                                                    );
                                                                                })}
                                                                            </TableRow>
                                                                        ))}
                                                                </TableBody>
                                                            </Table>
                                                    </Collapse>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </TableBody>
                    </Table>
                )}
            </Grid>
        </TableContainer>
    );
};

export default CorrespondenceTable;
